'use strict';

import $ from 'jquery';
import 'inputmask/dist/inputmask/jquery.inputmask';
import 'inputmask/dist/inputmask/inputmask.numeric.extensions';

let InputMask = require('inputmask/dist/inputmask/inputmask');

export function setupInputMask() {

    $('input').each(function () {
        let $input = $(this);
        let mask;

        switch ($input.data('mask')) {
            case 'number':
                mask = new InputMask('numeric', {
                    autoGroup: true,
                    groupSeparator: ' ',
                    radixPoint: ',',
                    rightAlign: false,
                    allowPlus: false,
                    allowMinus: false,
                    digits: $input.data('scale') || 0,
                    min: $input.data('min') || undefined,
                    max: $input.data('max') || undefined,
                });
                break;
        }

        if (mask) {
            mask.mask(this);
        }
    });
}



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/form.inputmask.js